module.exports = __webpack_public_path__ + "static/media/04.3c0eedb9.mp3";